import $ from 'jquery'
import { elementExists, elementIsVisible } from '../shared'
import { selectors } from '../selectors'

// TODO Refactor !!!

let map = {
    map: null,
    marker: null,
    infowindow: null,
}

const latLng = {
    lat: 50.0840361,
    lng: 14.4246819,
}

const mapOptions = {
    zoom: 15,
    center: latLng,
    mapTypeId: 'roadmap',
}

const contentString = `<h1>COOL CREDIT, s.r.o</h1>
        <span>Václavské náměstí 843/3</span>
        <span>110 00 Praha 1</span>
    <p>
        <a target="_blank" href="https://www.google.com/maps/dir//COOL+CREDIT,+s.r.o.,+V%C3%A1clavsk%C3%A9+n%C3%A1m.+841%2F3,+110+00+Nov%C3%A9+M%C4%9Bsto,+Czechia/@50.084036,14.4224933,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x470b94c7191d701f:0x25fe37255dfa62c2!2m2!1d14.424682!2d50.084036">Naplánovat trasu</a>
    </p>`

const elementIsScrolledTo = (element) => {
    if (!elementExists(element) || !elementIsVisible(element)) {
        return false
    }

    let $element = $(element)
    let hT = $element.offset().top,
        hH = $element.outerHeight(),
        wH = $(window).height(),
        wS = $(window).scrollTop()

    return wS > hT + hH - 100 - wH
}

//-- Inits
const initMap = () => {
    // InfoWindow
    map.infowindow = new google.maps.InfoWindow({
        content: contentString,
    })

    map.map = new google.maps.Map($(selectors.maps.mapCanvas)[0], mapOptions)

    $(window).scroll(() => {
        if (elementIsScrolledTo(selectors.maps.googleMap) && map.marker === null) {
            //Marker
            map.marker = new google.maps.Marker({
                position: latLng,
                map: map.map,
                icon: mapIconBase,
                baseIcon: mapIconBase,
                treeIcon: mapIconTree,
                animation: google.maps.Animation.DROP,
                clicked: true,
            })

            //Add listeners if everything is loaded
            addMapEventListeners()
            addMarkerEventListeners()
            addInfoWindowEventListeners()
        }
    })
}

//-- Listeners
const addMapEventListeners = () => {
    map.map.addListener('click', () => {
        map.infowindow.close()
        map.marker.clicked = false
    })
}

const addMarkerEventListeners = () => {
    map.marker.addListener('click', () => {
        if (map.marker.clicked) {
            map.infowindow.close()
        } else {
            map.infowindow.open(map.map, map.marker)
        }
        map.marker.clicked = !map.marker.clicked
    })
    map.marker.addListener('mouseover', () => map.marker.setIcon(map.marker.treeIcon))
    map.marker.addListener('mouseout', () => map.marker.setIcon(map.marker.baseIcon))
}

const addInfoWindowEventListeners = () => {
    map.infowindow.addListener('closeclick', () => (map.marker.clicked = !map.marker.clicked))
}

// ------------------ Init ------------------
export default function () {
    let googleMaps = selectors.maps.googleMaps

    if (!elementExists(googleMaps)) {
        let script = document.createElement('script')
        script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=' + process.env.GOOGLE_MAP_API_KEY)
        document.body.appendChild(script)

        script.onload = () => initMap()
    }
}
